




























































import {
	defineComponent, ref,
} from '@vue/composition-api';
import { v4 } from 'uuid';
import { EMPTY_COUNTRY, EMPTY_REGION } from '@front-app/components/inputs/CountryPickerData';
import {
	EventCurrency,
	PriceOption,
} from '@front-app/services/EventsApi/EventModel';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { HtmlString } from '@front-app/services/SharedModels';
import { Size, Spacing } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { toDatetimeLocal, toZonedDatetimeLocal } from '@front-app/util/format';
import { UpsertEventRequest } from '@front-app/services/EventsApi/EventsApi';
import { v } from '@front-app/components/form/validation/useValidation';
import { afterDate, required } from '@front-app/components/form/validation/validators';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import SimpleInputSection from '@front-app/components/form/SimpleInputSection.vue';
import TimePickerSection from '@front-app/components/form/TimePickerSection.vue';
import RichTextSection from '@front-app/components/form/RichTextSection.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { VisibilityOption } from '@front-app/services/GroupsApi/GroupEvent';
import { useEventAdminStore } from '../../store/EventAdmin';

export default defineComponent({
	components: {
		CtaButton,
		TrForm,
		SimpleInputSection,
		TimePickerSection,
		RichTextSection,
		SimpleCard,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const eventAdminStore = useEventAdminStore();
		const defaultEvent: UpsertEventRequest = {
			name: '',
			purpose: '' as unknown as HtmlString,
			startDate: (new Date()).toISOString(),
			endDate: '',
			isPublished: false,
			displayAttendanceCounts: false,
			allowRegistration: false,
			termsEnabled: false,
			requireTermsAcceptance: false,
			termsAndConditions: '',
			eventTypes: [],
			categories: [],
			visibility: VisibilityOption.USERS_WITH_ACCESS,
			location: {
				street1: '',
				street2: '',
				city: '',
				provStateRegion: EMPTY_REGION,
				country: EMPTY_COUNTRY,
				postalCode: '',
			},
			price: {
				value: '',
				type: PriceOption.NONE,
				numericValue: 0,
				currency: EventCurrency.CAD,
			},
			speakers: [],
			streams: [],
			onlineMeeting: {
				isEnabled: false,
				videoUrl: 'https://',
				videoButtonText: 'Online Meeting',
				videoButtonColor: '#0a60a6',
			},
		};

		const name = ref('');
		const purpose = ref('' as HtmlString);
		const startDate = ref(toDatetimeLocal(new Date()));
		const endDate = ref('');

		// Validation
		const validation = v({
			name: {
				value: name,
				rules: [required()],
			},
			startDate: {
				value: startDate,
				rules: [required()],
			},
			endDate: {
				value: endDate,
				rules: [afterDate(startDate)],
			},
		});

		const formId = `event-form-${v4()}`;
		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: `#${formId}` });

		const createEventStatus = useAsyncStatus();
		const submitForm = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			const requestData = { ...defaultEvent };
			requestData.name = name.value;
			requestData.purpose = purpose.value;
			requestData.startDate = toZonedDatetimeLocal(startDate.value) || '';
			requestData.endDate = toZonedDatetimeLocal(endDate.value) || '';
			const result = await createEventStatus.track(eventAdminStore.createGroupEvent(props.groupId, requestData));
			ctx.emit('created', result);
		};

		return {
			// Field values
			name,
			purpose,
			startDate,
			endDate,
			// Validation
			validation,
			// Submission
			submitForm,
			createEventStatus,
			// Util
			Spacing,
			formId,
			Size,
			ButtonPalettes,
		};
	},
});
